import { createContext, FC, PropsWithChildren } from 'react';
import { IModalWindow, useModalWindow, AppModal } from "../../ui/modal/ui/modal";

export const modalContext = createContext<IModalWindow>({
    isOpen: false,
    closeOnBlur: false,
    close: () => {},
    openModal: () => {}
});

interface IModalProviderProps extends PropsWithChildren {}

export const ModalProvider: FC<IModalProviderProps> = ({ children }) => {
    const modalWindow = useModalWindow();
    return <modalContext.Provider value={modalWindow}>
        <AppModal/>
        {children}
    </modalContext.Provider>;
}
